import { render, staticRenderFns } from "./InvoicesTab.vue?vue&type=template&id=0d8b8c1e&"
import script from "./InvoicesTab.vue?vue&type=script&lang=js&"
export * from "./InvoicesTab.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesTab.vue?vue&type=style&index=0&id=0d8b8c1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports